<!--- Copy Inventory Data-->
<div *ngIf="copyInventoryData" class="cob-dialog-wrapper">
	<div class="flex flex-col">
		<div class="flex flex-row w-100-percent pl-6">
			<div class="flex flex-col basis-full">
				<div class="fw-700 mat-headline-5 fs-20">{{ inventoryData?.name | titlecase }}</div>
				<div class="fs-16 fw-500">{{ cloudResourceType | titlecase}}</div>
			</div>
			<div class="flex flex-col mr-24">
				<button class="flex justify-end h-30 error-copy-class pt-4 pr-8 pb-4 pl-8"
					[ngClass]="[copy ? 'copied': 'copy']" (click)="copyText()">
					<span *ngIf="!copy" class="fs-16 fw-500 item flex items-center">
						<mat-icon class="h-18 w-18 mr-6" svgIcon="content_copy"></mat-icon>{{ 'ERROR_DIALOG.COPY' |
						transloco }}
					</span>
					<span *ngIf="copy" class="fs-16 fw-500 item flex items-center copied-text">
						<mat-icon class="h-18 w-18 mr-6" svgIcon="check"></mat-icon>{{ 'ERROR_DIALOG.COPIED' | transloco
						}}
					</span>
				</button>
			</div>
			<div class="flex flex-col mr-6">
				<mat-icon svgIcon="close" class="icon-lg cursor-pointer"
					(click)="sidenavService.closeRightSidenav()"></mat-icon>
			</div>
		</div>
		<mat-divider class="w-100-percent mt-16 mb-16 mat-divider-inner"></mat-divider>
		<div class="flex flex-row w-100-percent json-line-wrapper pl-6">
				<div class="json-data">
				<div class="json-line" *ngFor="let line of formattedLines; let i = index">
					<span class="line-number">{{ i + 1 }}.</span>
					<span class="line-content">{{ line }}</span>
				</div>
			</div>
		</div>
	</div>
</div>
<!--Copy Inventory Data Ends-->

<!--- View Inventory Data-->
<div *ngIf="!copyInventoryData" class="default-dialog-wrapper"
	[ngClass]="typeCountList?.length > 17 ? 'cob-dialog-wrapper' : 'view-dialog-wrapper'">
	<div class="flex flex-col">
		<div class="flex flex-row w-100-percent pl-6">
			<div class="flex flex-col basis-full">
				<div class="fw-700 mat-headline-5 fs-20">{{ 'INVENTORY.RESOURCE_BY_TYPE' | transloco}}</div>
				<div class="fs-16 fw-500">{{ instanceName | titlecase }}</div>
			</div>
			<div class="flex flex-col mr-24">
				<button class="flex justify-center items-center sort pl-8 pr-8 pb-4 pt-4 h-26"
					(click)="sortInventoryCloud()">
					<mat-icon class="icon-sm mr-4" [ngStyle]="{ transform: isAsc ? 'rotate(0deg)' : 'rotate(180deg)' }"
						svgIcon="sort_by_alpha"></mat-icon>
					<span class="mat-body-1 fw-500">{{'INVENTORY.SORT' | transloco }}</span>
				</button>
			</div>
			<div class="flex flex-col mr-6">
				<mat-icon svgIcon="close" class="icon-lg cursor-pointer"
					(click)="sidenavService.closeRightSidenav()"></mat-icon>
			</div>
		</div>
		<mat-divider class="w-100-percent mt-16 mb-16 mat-divider"></mat-divider>

		<div *ngIf="typeCountList?.length > 17" class="flex flex-row gap-6">
			<!-- Left Column -->
			<div class="flex flex-col w-1/2 pl-6">
				<div class="flex flex-col" *ngFor="let data of typeCountList1 ; let last = last">
					<div class="flex flex-row items-center w-full">
						<div class="w-1/2 truncate fw-40 fs-14">{{ data.type | titlecase  }}</div>
						<div class="flex-1 mx-2">
							<div class="progress-bar" [ngStyle]="{ width: data.count+'px' }"></div>
						</div>
						<div class="w-25 text-right fw-600 fs-16"> {{(data.count) > 10 ? data.count : '0'+data.count  }}</div>
					</div>
					<mat-divider *ngIf="!last" class="mt-8 mb-8"></mat-divider>
				</div>
			</div>
			<!-- Right Column -->
			<div class="flex flex-col w-1/2 pr-6">
				<div class="flex flex-col" *ngFor="let data of typeCountList2 ; let last = last">
					<div class="flex flex-row items-center w-full">
						<div class="w-1/2 truncate fw-40 fs-14">{{ data.type | titlecase  }}</div>
						<div class="flex-1 mx-2">
							<div class="progress-bar" [ngStyle]="{ width: data.count+'px' }"></div>
						</div>
						<div class="w-25 text-right fw-600 fs-16"> {{(data.count) > 10 ? data.count : '0'+data.count  }}</div>
					</div>
					<mat-divider *ngIf="!last" class="mt-8 mb-8"></mat-divider>
				</div>
			</div>

		</div>

		<div *ngIf="!(typeCountList?.length > 17)" class="flex flex-row gap-6">
			<div class="flex flex-col w-full pl-6">
				<div class="flex flex-col" *ngFor="let data of typeCountList ; let last = last">
					<div class="flex flex-row items-center w-full">
						<div class="w-1/2 truncate fw-40 fs-14">{{ data.type | titlecase }}</div>
						<div class="flex-1 mx-2">
							<div class="progress-bar" [ngStyle]="{ width: data.count+'px' }"></div>
						</div>
						<div class="w-25 text-right fw-600 fs-16"> {{(data.count) > 10 ? data.count : '0'+data.count  }} </div>
					</div>
					<mat-divider *ngIf="!last" class="mt-8 mb-8"></mat-divider>
				</div>
			</div>
		</div>

	</div>
</div>
<!--View Inventory Data Ends-->
